/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonStratUser,
    JsonStratUserFromJSON,
    JsonStratUserFromJSONTyped,
    JsonStratUserToJSON,
} from './JsonStratUser';

/**
 * 
 * @export
 * @interface ApiResultOfListOfJsonStratUser
 */
export interface ApiResultOfListOfJsonStratUser {
    /**
     * 
     * @type {Array<JsonStratUser>}
     * @memberof ApiResultOfListOfJsonStratUser
     */
    data?: Array<JsonStratUser>;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonStratUser
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfListOfJsonStratUser
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonStratUser
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonStratUser
     */
    result?: ApiResultOfListOfJsonStratUserResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfListOfJsonStratUserResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfListOfJsonStratUserFromJSON(json: any): ApiResultOfListOfJsonStratUser {
    return ApiResultOfListOfJsonStratUserFromJSONTyped(json, false);
}

export function ApiResultOfListOfJsonStratUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfListOfJsonStratUser {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(JsonStratUserFromJSON)),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfListOfJsonStratUserToJSON(value?: ApiResultOfListOfJsonStratUser | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(JsonStratUserToJSON)),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

